import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUsers, faHandshake, faMoneyCheckDollar, faEyeSlash, faVideoSlash, faPersonCircleQuestion, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './About.css';

const AbwabAboutUs = () => {
    const stats = [
        {
            icon: faHandshake,
            text: "أبواب الخير تتعامل مع الحالات بشكل مباشر فقط وتقرر أوجه المساعدة بعد زيارة مباشرة ولا تتعامل ابدا عبر وسطاء"
        },
        {
            icon: faMoneyCheckDollar,
            text: "نهتم بجودة أي مساعدات نقدمها فالأهم الجودة وليست الكمية"
        },
        {
            icon: faEyeSlash,
            text: "أبواب الخير أبدا لا تضع أسماء أو صور لحالات تعمل عليها فكرامة الناس خط أحمر"
        },
        {
            icon: faVideoSlash,
            text: "لا نلجأ الى الاعلانات التليفزيونية فالحالات أحق بالتبرعات"
        },
        {
            icon: faUsers,
            text:"نعمل بلا تمييز ونقدم المساعدة لأي انسان يحتاج الى المساعدة"
        },
        {
            icon: faPersonCircleQuestion,
            text:"كفالاتنا مناسبة تكفي الناس شر السؤال"
        }
    ];


    return (
        <div className="about-page AbwabAboutUs">
            {/* Hero Section */}
            <section className="about-hero">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6} className="about-hero-content">
                            <h1 className="about-hero-title">
                                عن أبواب الخير
                            </h1>
                            <span className='about-campaign-text mb-5'>
                                الحكاية بدأت بحالة واحدة بس!
                                القصة بدأت لما هيثم التابعي (الصحفي ومؤسس أبواب الخير) قرر هو ومجموعة من أصدقاءه التكفل بحالة واحدة كانوا بيوصلوا ليها مساعدة شهرية .. مع الوقت الحالة بقت اتنين وتلاتة ودايرة الخير بدأت تكبر
                                يوم بعد يوم المبادرة الشخصية بدأت تكبر وشغلها يتوسع وفي 2018 في يوم 28 يونيو 2018 تم قيد المؤسسة بالإدارة المركزية للجمعيات والاتحادات بوزارة التضامن الاجتماعي وأصبحت مؤسسة رسمية مشهرة برقم 846
                            </span>

                        </Col>
                        <Col lg={6} className="about-hero-image">
                            <div className="ratio ratio-16x9">
                                <iframe 
                                    src="https://www.youtube.com/embed/_Pf8llxoxd0" 
                                    title="About Abwab"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="rounded"
                                ></iframe>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* Stats Section */}
            <section className="about-stats">
                <Container>
                    <Row>
                        {stats.map((stat, index) => (
                            <Col md={6} lg={4} key={index} className="mb-4">
                                <Card className="about-stat-card h-100">
                                    <Card.Body className="text-center mt-3">
                                        <FontAwesomeIcon icon={stat.icon} className="about-stat-icon" />
                                        <h3 className="about-stat-number">{stat.number}</h3>
                                        <p className="about-stat-text">{stat.text}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>


            {/* Closing Section */}
            <section className="about-closing">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} className="text-center">
                            <p className="about-closing-text">
                                في أبواب الخير، هدفنا هو تقديم المساعدة الكريمة والفعالة لكل محتاج، بعيدًا عن أي استعراض أو وساطة. نؤمن أن كل دعم يقدم هو باب أمل جديد يُفتح لأسرة أو فرد في أمس الحاجة.
                            </p>
                            <p className="about-closing-text">
                                مع كل تبرع، أنتم شركاؤنا في الخير.. ساعدونا نكمل المشوار ونوصل الدعم لمن يستحق.
                            </p>
                            <div className="contact-info mt-4">
                                <p className="about-closing-text"><strong>للتواصل معنا:</strong></p>
                                <p className="about-closing-text">
                                    <a href="tel:01009006768" className="text-decoration-none nav-link">
                                        01009006768  
                                        <FontAwesomeIcon icon={faPhone} className="me-2" />
                                    </a>
                                </p>
                                <p className="about-closing-text">
                                    <a href="mailto:info@abwabelkheir.com" className="text-decoration-none nav-link">
                                        info@abwabelkheir.com
                                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                    </a>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </div>
    );
};

export default AbwabAboutUs;
